import { Link, useSearchParams } from "react-router-dom";
import { Clock3, RefreshCw, Sparkles } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useLiveResource } from "@/hooks/useLiveResource";
import { PageError, PageLoading } from "@/components/LiveState";
import PageFrame from "@/components/agent-workspace/PageFrame";
import SkillLibrary from "@/components/skills/SkillLibrary";
import AgentAutomations from "./AgentAutomations";

function SkillsTab() {
  const { activeClient } = useApp();
  const resource = useLiveResource("getSkills");
  if (resource.status === "loading" && !resource.data)
    return <PageLoading label="Loading your agent’s skills…" />;
  if (resource.error || resource.status === "error")
    return (
      <PageError
        error={resource.error}
        onRetry={resource.reload}
        title="Skills unavailable"
      />
    );
  return (
    <>
      <div className="sa-refresh">
        <button
          type="button"
          className="btn-outline inline-flex items-center gap-2"
          disabled={resource.status === "loading"}
          onClick={() => resource.reload().catch(() => undefined)}
        >
          <RefreshCw size={13} />
          Refresh skills
        </button>
      </div>
      <SkillLibrary
        skills={resource.data?.skills ?? []}
        changes={resource.data?.changes ?? []}
        workspace={activeClient}
      />
    </>
  );
}

export function SkillsAutomationsFrame({ skills, automations }) {
  const [params] = useSearchParams();
  const selected = params.get("tab") === "skills" ? "skills" : "automations";
  return (
    <PageFrame
      title="Skills & Automations"
      subtitle="What your agent knows. What it takes care of for you."
      testId="skills-automations-page"
    >
      <nav className="sa-page-tabs" aria-label="Skills and automations">
        <Link
          to="?tab=automations"
          aria-current={selected === "automations" ? "page" : undefined}
        >
          <Clock3 size={16} />
          Automations
        </Link>
        <Link
          to="?tab=skills"
          aria-current={selected === "skills" ? "page" : undefined}
        >
          <Sparkles size={16} />
          Skills
        </Link>
      </nav>
      {selected === "skills" ? skills : automations}
    </PageFrame>
  );
}
export default function AgentSkillsAutomations() {
  const { activeClient } = useApp();
  return (
    <SkillsAutomationsFrame
      skills={<SkillsTab key={activeClient?.clientSlug || ""} />}
      automations={<AgentAutomations embedded />}
    />
  );
}
